// Import required libraries
import React from "react";
import { connect } from "react-redux";

// Import custom components
import RbLogo from "../RBLogo/RbLogo";
import UserInfo from "../UserInfo/UserInfo";
// Import styles
import "./Header.scss";
import { Button } from "@material-ui/core";

// Import config

function Header(props) {
  const { user, match } = props;
  const handleRaiseTicket = (e) => {
    e.processEvent?.stopPropagation();
    const PORTAL_URL =
      user?.ticketPortal?.portal_url || "https://portal.rebelforge.com";
    window.open(PORTAL_URL, "_blank");
  };

  return (
    <>
      <header className={user.theme}>
        <RbLogo match={match} />
        <section className="header-menu">
          {user?.ticketPortal?.isVisible && (
            <Button
              onClick={handleRaiseTicket}
              style={{
                backgroundColor: "#ea3592",
                fontFamily: "Hind Siliguri",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: "bold",
                marginRight: "5px",
                color: "white",
              }}
            >
              <span>
                <i
                  className="material-icons-outlined"
                  style={{
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#ffffff",
                    marginRight: "-30px",
                    verticalAlign: "middle",
                  }}
                >
                  {user?.ticketPortal?.button_icon || ""}
                </i>
              </span>
              {user?.ticketPortal?.button_text || ""}
            </Button>
          )}
          <UserInfo {...props} />
        </section>
      </header>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Header);
